import { render, staticRenderFns } from "./CreateAttributeModal.vue?vue&type=template&id=6a21536e&scoped=true&"
import script from "./CreateAttributeModal.vue?vue&type=script&lang=js&"
export * from "./CreateAttributeModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateAttributeModal.vue?vue&type=style&index=0&id=6a21536e&prod&scoped=true&lang=scss&"
import style1 from "./CreateAttributeModal.vue?vue&type=style&index=1&id=6a21536e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a21536e",
  null
  
)

export default component.exports